import { Loader2 } from "lucide-react";
import ChatWindow from "./ChatWindow";
import { UserProfile } from "@/types/user";
import { ChatType, ChatMessage } from "./types";

type ChatMainWindowProps = {
  loading: boolean;
  selectedChatId: string | null;
  recipient: UserProfile | null;
  messages: ChatMessage[];
  currentUserId: string;
  onSendMessage: (message: string) => void;
  onProfilePicChange?: (userId: string, newAvatarUrl: string) => void;
  chatType?: ChatType;
  groupName?: string;
  groupMembers?: UserProfile[];
  onInviteMembers?: () => void;
};

export default function ChatMainWindow({
  loading,
  selectedChatId,
  recipient,
  messages,
  currentUserId,
  onSendMessage,
  onProfilePicChange,
  chatType = "individual",
  groupName,
  groupMembers = [],
  onInviteMembers,
}: ChatMainWindowProps) {
  return (
    <div className="w-full h-full flex flex-col overflow-hidden">
      {loading ? (
        <div className="flex h-full items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      ) : selectedChatId && recipient ? (
        <ChatWindow
          recipient={recipient}
          messages={messages}
          onSendMessage={onSendMessage}
          currentUserId={currentUserId}
          onProfilePicChange={onProfilePicChange}
          chatType={chatType}
          groupName={groupName}
          members={groupMembers}
          onInviteMembers={onInviteMembers}
        />
      ) : (
        <div className="flex h-full items-center justify-center text-muted-foreground">
          <p className="text-center max-w-xs">
            Select a conversation or start a new one by clicking on a contact
          </p>
        </div>
      )}
    </div>
  );
}
